import type { HistoryDataChange } from 'components/core/History';
import type { CategoryHistorySnapshot } from '../types';

/**
 * Category metadata is `Record<string, { value, inherited }>`, so diff paths end with
 * `.value`/`.inherited` - unlike asset metadata, where the key itself is the leaf.
 * Comparing paths for equality (as `createIsFieldChanged` does) would never match here.
 */
export function createIsMetadataKeyChanged(changes: HistoryDataChange[]) {
    return function isMetadataKeyChanged(key: string): boolean {
        return changes.some((change) => change.path.startsWith(`additional.metadata.${key}.`));
    };
}

export function getMetadataEntries({ additional }: CategoryHistorySnapshot) {
    return Object.entries(additional?.metadata ?? {});
}

/**
 * `CategoryImages` types the known keys as `never` with a `[key: string]: string` index,
 * so the map has to be read through entries rather than property access.
 */
export function getAdditionalImages({ additional }: CategoryHistorySnapshot) {
    return Object.entries(additional?.images ?? {});
}

export function formatVisibility(showCategory: boolean): string {
    return showCategory === false ? 'Archived' : 'Visible';
}

export function formatBoolean(value: boolean): string {
    return value ? 'Yes' : 'No';
}
